module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Extrabld.6b3b24a13551b9b1cafe55faa5689041.eot";